const SENSITIVE_KEYS = new Set([
  'password',
  'refreshToken',
  'refreshTokenUpdatedAt',
  'clientRefreshTokens',
  'fcmToken',
  'fcmTokens',
]);

const ROLE_LABELS = {
  admin: 'Администратор',
  client: 'Заказчик',
  respondent: 'Респондент',
};

const FIELD_LABELS = {
  id: 'ID',
  email: 'Email',
  fullName: 'ФИО',
  phone: 'Телефон',
  role: 'Роль',
  companyName: 'Компания',
  balance: 'Баланс (BYN)',
  points: 'Баллы',
  referralPoints: 'Реферальные баллы',
  referralCode: 'Реферальный код',
  referredBy: 'Пригласил (ID)',
  isPhoneVerified: 'Телефон подтверждён',
  suspended: 'Заблокирован',
  surveyCount: 'Кол-во опросов',
  completedSurveyCount: 'Завершено опросов',
  createdAt: 'Дата регистрации',
  updatedAt: 'Дата обновления',
  avatar: 'Аватар',
  dynamicProfile: 'Динамический профиль',
  profile: 'Профиль',
  platform: 'Платформа',
  mobileAppVersion: 'Версия приложения',
  gender: 'Пол',
  age: 'Возраст',
  city: 'Город',
  region: 'Регион',
  education: 'Образование',
  maritalStatus: 'Семейное положение',
  employment: 'Занятость',
  income: 'Доход',
  interests: 'Интересы',
  notifications: 'Настройки уведомлений',
};

const formatCellValue = (key, value) => {
  if (value === null || value === undefined) return '';
  if (key === 'role') return ROLE_LABELS[value] || value;
  if (key === 'suspended' || key === 'isPhoneVerified') return value ? 'Да' : 'Нет';
  if (key === 'createdAt' || key === 'updatedAt') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleString('ru-RU');
  }
  if (typeof value === 'object') return JSON.stringify(value);
  return value;
};

export const userToExcelRow = (user) => {
  const row = {};
  Object.entries(user || {}).forEach(([key, value]) => {
    if (SENSITIVE_KEYS.has(key)) return;
    const label = FIELD_LABELS[key] || key;
    row[label] = formatCellValue(key, value);
  });
  return row;
};

export const usersToExcelRows = (users) => (users || []).map(userToExcelRow);
